
import MeaPage from "../../../components/MeaPage";
import SecretariatWorkspaceBar from "../components/SecretariatWorkspaceBar";
import TrainingHeader from "./components/TrainingHeader";
import { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import trainingsAPI from "../../../services/trainings";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import TrainingTilesComponent from "./components/TrainingTilesComponent";

const TrainingInfoPage = () => {

  //
  const updateModalRef = useRef();
  const toast = useRef();
  //
  const params = useParams();
  const schoolId = params.schoolId
  const trainingId = params.trainingId;
  const navigate = useNavigate();
    const accessToken = "";
  const trainingQuery = trainingsAPI.GetOne(
    schoolId,
    trainingId,
    accessToken
  );
  const trainingObj = trainingQuery?.data?.data;

  //
  return (
    <>
      <MeaPage 
        title={`Feuilles de présence - ${trainingObj?.name || "Formation"}`}
        breadcrumb={<SecretariatWorkspaceBar section="presences" training={trainingObj} />}
        showBackButton={true}
        onBackButtonClick={() => navigate(`/school/${schoolId}/secretariat`)}
      >


        <TrainingTilesComponent training={trainingObj} />


        <ConfirmDialog />
        <Toast ref={toast} />


      </MeaPage>
    </>
  );
};
export default TrainingInfoPage;
